import { AuthType } from '../../types/response';

export const SET_AUTH = '[AUTH] set auth';
export const LOGOUT = '[AUTH] logout';

export const setAuth = (payload: AuthType) => ({
  type: SET_AUTH,
  payload,
});

export const logout = () => ({
  type: LOGOUT,
});

class SetAuth {
  readonly type = SET_AUTH;
  constructor(public payload: AuthType) {}
}

class Logout {
  readonly type = logout;
}

export type AuthActionType = SetAuth | Logout;
